export class DashboardButtonModel {
    public constructor(
        public titleText: string,
        public bodyText: string,
        public forceDashboard = false,
    ) {}
}
